<template lang="pug">
v-dialog(v-model="show", v-if="estabelecimentoDisponiveis && estabelecimentoDisponiveis.length", width="50%", max-height="70%")
    v-card
      v-card-title.title Lojas
      v-card-text
        v-layout(row, wrap)
          v-flex.md12
            v-text-field(append-icon='search', outline, color="gray", label='Buscar loja', type="text", v-model="search", clearable)
        v-layout(row, wrap)
          v-flex.md12
            v-list(three-line)
              template(v-for='(estabelecimento, i) in estabelecimentosVisiveis')
                v-list-tile
                  v-list-tile-action
                    v-icon(:color="isAberto(estabelecimento) ? 'primary' : 'orange'", small).fa fa-circle
                  v-list-tile-content
                    v-list-tile-title.content-text {{ estabelecimento.nome }}
                    v-list-tile-sub-title.content-text {{estabelecimento.localidade}} - {{estabelecimento.estado}}
                      br
                      BadgeOrigem(:cardapio_digital="estabelecimento.cardapio_digital ? true : false", :label="true")
                  v-list-tile-action
                    v-btn.btnDelivery(small, :loading="estabelecimento.loading", depressed, outline, @click="isAberto(estabelecimento) ? openDialogCloseTimer(estabelecimento) : openLoja(estabelecimento)")
                      .body-1.font-weight-bold.pa-1 {{ isAberto(estabelecimento) ? 'Fechar' : 'Abrir' }} loja
                v-divider
              v-list-tile(v-if="totalRestante > 0", ref="sentinela", @click="mostrarMais()")
                v-list-tile-content
                  v-list-tile-title.text-xs-center.primary--text Mostrar mais {{ proximoPasso }} (restam {{ totalRestante }})
      v-card-actions
        v-spacer
        v-btn(@click="close()", flat) Fechar

    DialogCloseTimer(ref="dialogCloseTimer", @refresh="refresh")
</template>

<script>
import _ from "lodash";
import DialogCloseTimer from '@/components/dialog/DialogCloseTimer';
import BadgeOrigem from "@/components/BadgeOrigem";
import listaLojasIncremental from "@/mixins/listaLojasIncremental";


export default {
  mixins: [listaLojasIncremental],
  components: {
    DialogCloseTimer,
    BadgeOrigem
  },
  props: {
  },
  data () {
    return {
        show : false,
        loading: false,
        search: null,
        // aplicado com debounce: evita refiltrar a lista inteira a cada tecla
        searchAplicado: null,
        estabelecimentoSelecionado: null,
        estabelecimentoDisponiveis: []
    }
  },
  created () {
    window.getApp.$on("UPDATE_DELIVERY_LIST", this.updateEstabelecimentos);
    this.aplicarBusca = _.debounce(valor => {
      this.searchAplicado = valor;
      this.resetLimite();
    }, 200);
  },
  beforeDestroy() {
    window.getApp.$off("UPDATE_DELIVERY_LIST", this.updateEstabelecimentos);
    if (this.aplicarBusca) this.aplicarBusca.cancel();
  },
  mounted() {
  },
  watch: {
    '$root.estabelecimentos': {
      handler () {
        this.updateEstabelecimentos()
      },
    },
    search (valor) {
      this.aplicarBusca(valor || null);
    },
  },
  computed: {
    listaOrdenada(){
      return _.sortBy(this.estabelecimentoDisponiveis, 'nome')
    },
    estabelecimentos(){
      return this.$root.searchLojas(this.listaOrdenada, this.searchAplicado)
    },
  },
  methods: {
    open(){
      this.show = true;
      this.search = null
      this.searchAplicado = null
      this.resetLimite()
      this.updateEstabelecimentos()
    },
    close(){
      this.show = false;
    },
    updateEstabelecimentos(){
      if(this.show == false) return;
      this.estabelecimentoDisponiveis = _.cloneDeep(this.$root.estabelecimentos || []);
      this.$forceUpdate()
    },
    refresh(){
      this.$forceUpdate();
      this.$emit('refresh');
    },
    isAberto(estabelecimento){
      const delivery = estabelecimento.delivery ? estabelecimento.delivery[0] : null
      return delivery && delivery.aberto == 1 ? true : false;
    },
    openDialogCloseTimer(estabelecimento){
      this.$refs.dialogCloseTimer.open(estabelecimento, false);
    },
    async openLoja(estabelecimento){
      const isPendente = (estabelecimento.vendas || []).some(v =>
        v.status == this.$root.enums.STATUS.VENDA_PENDENTE
      );
      // Só bloqueia se também tiver registro de onboarding criado pelo admin
      if (isPendente && this.$root.onboardingData && this.$root.onboardingData.id) {
        window.getApp.$emit('OPEN_ONBOARDING');
        return;
      }
      try{
        estabelecimento.loading = true;
        const delivery = estabelecimento.delivery[0];
        const response = await this.$axios.post('/abrir', delivery);
        estabelecimento.delivery[0] = response.data;
        this.refresh(estabelecimento);
        estabelecimento.loading = false;
      }catch(error){
        const err = error.response && error.response.data ? error.response.data.error : null;
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err || 'Não foi possível abrir a loja. Por favor, tente novamente.' });
        estabelecimento.loading = false;
      }
    },
  }
  }
</script>

<style lang="scss" scoped>
.content-text{
  white-space: normal;
  word-wrap: break-word;
  height: auto;
}
</style>
